import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSelector } from 'react-redux';
import lodashIsEmpty from 'lodash/isEmpty';

import CartItem from '../../Components/StoreCart/CartItem';
import MealPlanItem from '../../Components/StoreCart/MealPlanItem';
import CartHelper from '../../Helper/Cart';
import MealPlanHelper from '../../Helper/MealPlan';
import useMealPlan from '../../Hooks/useMealPlan';
import { selectCart } from '../../RTK/cart/selectors';
import { checkoutStoreInfoSelector } from '../../RTK/checkout/selectors';
import { selectMealPlanCart } from '../../RTK/mealPlan/selectors';
import { globalSpacing } from '../../Theme/styles';

const CheckoutItems = () => {
  const { isMealPlan } = useMealPlan();
  const checkoutInfo = useSelector(checkoutStoreInfoSelector);
  const allScheduleCart = useSelector(selectMealPlanCart);
  const cartItems = useSelector(
    // @ts-ignore: selector is js file, but it should accept 2nd parameter
    (state) => selectCart(state, checkoutInfo.store_id)?.[0]?.items,
  );
  const mealPlanSchedule = useMemo(() => {
    if (lodashIsEmpty(allScheduleCart)) return [];
    return MealPlanHelper.generateSchedule(`${allScheduleCart.length}_day`);
  }, [allScheduleCart]);
  if (isMealPlan) {
    return allScheduleCart.map((mealCart, index) => {
      return mealCart.items.map((mealCartItem) => {
        return (
          <MealPlanItem
            key={`${mealCart.day}.${CartHelper.getCartDetailsId(mealCartItem)}`}
            date={mealPlanSchedule[index]}
            {...mealCartItem}
          />
        );
      });
    });
  } else {
    return (
      <View style={styles.marginOffset}>
        {cartItems?.map?.((item) => <CartItem key={item.item_id} {...item} />)}
      </View>
    );
  }
};

const styles = StyleSheet.create({
  marginOffset: {
    marginHorizontal: -globalSpacing,
    marginTop: -(globalSpacing / 8),
    marginBottom: -(globalSpacing / 4),
  },
});

export default CheckoutItems;
